<script>
import ReportingApi from "@/services/reporting-api";

export default {
      props: {
        isMonthly: {
            type: Boolean,
            default: false,
        },
        isYearly :{
            type: Boolean,
            default: false,
        },

        currentMonth:Number,
        currentYear:Number
    },

  computed: {
    role() {
      return this.$cookies.get('userr');
    },
  },

  


  mounted(){
    
    this.getTotalTurnover();
  },
  data() {
    return {
     
      month:this.currentMonth,
      year:this.currentYear,
      monthly_turnover:0,
      yearly_turnover:0,
      increase:null,
      increaseAsString:null,

    };


  },

  methods: {
    getTotalTurnover(){
        ReportingApi.getTotalTurnover(this.month,this.year,this.isMonthly,this.isYearly).then(
            (result)=>{
              if(result){
                if(this.isMonthly){
                  this.monthly_turnover =result.selectedPeriodValueAsString ===null ? 0 : result.selectedPeriodValueAsString
                  this.increase=result.increase
                  this.increaseAsString=result.increaseAsString
                }

                if(this.isYearly){
                  this.yearly_turnover =result.selectedPeriodValueAsString ===null ? 0 : result.selectedPeriodValueAsString
                  this.increase=result.increase
                  this.increaseAsString=result.increaseAsString
                }
              }

                
            }
        )
    },


},
    watch : {
        year : function() {
              this.getTotalTurnover() 
        },
        month : function() {
              this.getTotalTurnover() 
        }
  }

};
</script>

<template>
  <div class="card mini-stats-wid m-2">
    <div class="card-body h-100 p-0">
      <div class="media">
        <div class="media-body">
        <div class="clearfix m-4">
          <div class="float-right ">
            <div v-if="isMonthly" class="input-group input-group-sm">
                <select class="custom-select custom-select-sm"  v-model="month">
                  <option v-if="currentMonth>=0" selected value="0">{{$t('months.0')}}</option>
                  <option v-if="currentMonth>=1" value="1">{{$t('months.1')}}</option>
                  <option v-if="currentMonth>=2" value="2">{{$t('months.2')}}</option>
                  <option v-if="currentMonth>=3" value="3">{{$t('months.3')}}</option>
                  <option v-if="currentMonth>=4" value="4">{{$t('months.4')}}</option>
                  <option v-if="currentMonth>=5" value="5">{{$t('months.5')}}</option>
                  <option v-if="currentMonth>=6" value="6">{{$t('months.6')}}</option>
                  <option v-if="currentMonth>=7" value="7">{{$t('months.7')}}</option>
                  <option v-if="currentMonth>=8" value="8">{{$t('months.8')}}</option>
                  <option v-if="currentMonth>=9" value="9">{{$t('months.9')}}</option>
                  <option v-if="currentMonth>=10" value="10">{{$t('months.10')}}</option>
                  <option v-if="currentMonth>=11" value="11">{{$t('months.11')}}</option>
                </select>
                <div class="input-group-append">
                  <label class="input-group-text">{{$t('months.label')}}</label>
                </div>
            </div>
            <div v-if="isYearly" class="input-group input-group-sm"> 




              <select class="custom-select custom-select-sm" v-model="year">
                <option v-for="year in Array.from({length: this.currentYear -1 - 2019}, (value, index) => 2020 + index)" :key="year" :value="year">{{ year }}</option>
                <option selected :value="this.currentYear">{{this.currentYear}}</option>
              </select>




                <!-- <select class="custom-select custom-select-sm" v-model="year">
                  <option  :value="this.currentYear-1">{{this.currentYear-1}}</option>
                  <option selected :value="this.currentYear">{{this.currentYear}}</option>
                </select> -->
              
              
                <div class="input-group-append">
                  <label class="input-group-text">{{$t('years.label')}}</label>
            </div>
            </div>
          </div>
    
    <h4 v-if="isMonthly && role==0" class="card-title text-dark font-size-18 mb-4">{{$t('reporting.customer.earning.monthly')}}<span class="font-size-12"> ({{$t('amounts.withoutTaxes')}}, {{this.currentYear}})</span></h4>
    <h4 v-if="isMonthly && role==1" class="card-title text-dark font-size-18 mb-4">{{$t('reporting.supplier.earning.monthly')}} <span class="font-size-12"> ({{$t('amounts.withoutTaxes')}}, {{this.currentYear}})</span></h4>

    <h4 v-if="isYearly && role==0" class="card-title text-dark font-size-18 mb-4">{{$t('reporting.customer.earning.yearly')}}<span class="font-size-12"> ({{$t('amounts.withoutTaxes')}})</span></h4>
    <h4 v-if="isYearly && role==1" class="card-title text-dark font-size-18 mb-4">{{$t('reporting.supplier.earning.yearly')}}<span class="font-size-12"> ({{$t('amounts.withoutTaxes')}})</span></h4>

        </div>
  <div class="row"  >
  <div  v-if="isMonthly" class="col-sm-6" style =" padding-left:26px">
  <h3   >{{this.monthly_turnover}} </h3>
  <p :class="increase == null ? 'invisible' :'' " class="text-muted font-size-14" >
    <span  :class="increase>0 ?'text-success mr-2' : 'text-danger mr-2'">
       {{Math.round(increase)}}%
      <i :class="increase>0 ?'mdi mdi-arrow-up' : 'mdi mdi-arrow-down'"></i>
    </span>% {{$t("months.previous")}}
  </p>
  </div>
    <div v-if="isYearly" class="col-sm-6" style =" padding-left:26px">
  <h3  >{{this.yearly_turnover}} </h3>

    <p :class="increase == null ? 'invisible' :'' "  class="text-muted font-size-14">
    <span :class="increase>0 ?'text-success mr-2' : 'text-danger mr-2'">
      {{Math.round(increase)}}%
      <i :class="increase>0 ?'mdi mdi-arrow-up' : 'mdi mdi-arrow-down'"></i>
    </span>% {{$t("years.previous")}}
  </p>

  </div>
  <div class="col-sm-3"> </div>
  <div class="col-sm-3" >
        <div class="mini-stat-icon avatar-sm align-self-center rounded-circle float-right m-4 d-none d-sm-block ">
          <span class="avatar-title">
            <i v-if="isYearly" class="fas fa-dollar-sign font-size-24"></i>
            <i v-if="isMonthly" class="fas fa-file-invoice-dollar   font-size-24"></i>
          </span>
        </div>
  </div>
          </div>
        </div>


      </div>
    </div>
    <!-- end card-body -->
  </div>
</template>